import { getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import load_html5_videos_controller from './load_html5_videos_controller'

var $target = undefined
var lastTypeOfContentThatIsReady = undefined
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		setTimeout(function () {
			initPlayerControls($target)
		}, 0)
		lastTypeOfContentThatIsReady = typeOfContentThatIsReady
	})

	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		setTimeout(function () {
			initPlayerControls($target)
		}, 0)
	})

	window.laytheme.on('overlayhidden', function () {
		$target = getTargetContainersExceptPageOverlay(lastTypeOfContentThatIsReady)
		// dont need to do initPlayerControls again, because this page's thumbnailgrid was already initialized
	})
}

var CustomControls = function ($el) {
	this.$el = $el
	this.video = $el[0]
	// Target both .html5video and .video containers (for custom filters)
	this.parent = this.video.closest('.html5video, .video')

	var controlsMarkup = '<div class="lay-vimeo-custom-controls">' + '<div class="lay-vimeo-playicon-custom">' + '<img src="' + layData.playicon + '" alt=""/>' + '</div>' + '<div class="lay-vimeo-playpause">' + '<svg class="lay-vimeo-play" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M8 5L19 12L8 19V5Z" fill="white"/>' + '</svg>' + '<svg class="lay-vimeo-pause" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M8 5H12V19H8V5Z" fill="white"/>' + '<path d="M16 5H20V19H16V5Z" fill="white"/>' + '</svg>' + '</div>' + '<div class="lay-controls-flex-wrap">' + '<div class="lay-vimeo-seekbar-outer">' + '<div class="lay-vimeo-seekbar">' + '<div class="lay-vimeo-seekbar-inner"></div>' + '</div>' + '</div>' + '<div class="lay-vimeo-volume">' + '<div class="lay-vimeo-volume-button">' + '<svg class="lay-vimeo-volume-on" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M11 5L6 9H2V15H6L11 19V5Z" fill="white"/>' + '<path d="M15.54 8.46C16.4774 9.39764 17.004 10.6692 17.004 11.995C17.004 13.3208 16.4774 14.5924 15.54 15.53" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '<path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg>' + '<svg class="lay-vimeo-volume-off" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M11 5L6 9H2V15H6L11 19V5Z" fill="white"/>' + '<path d="M23 9L17 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '<path d="M17 9L23 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg>' + '</div>' + '<div class="lay-vimeo-volume-slider-outer">' + '<div class="lay-vimeo-volume-slider">' + '<div class="lay-vimeo-volume-slider-inner"></div>' + '</div>' + '</div>' + '</div>' + '<div class="lay-vimeo-share">' + '<svg width="18" height="18" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">' + '<g> <path fill="#ffffff" d="M246,101.8L141.1,10v53.7C10,95.2,10,246,10,246s45.6-106,131.1-106v53.6L246,101.8z"/></g>' + '</svg>' + '</div>' + '<div class="lay-vimeo-fullscreen"></div>' + '</div>' + '</div>'
	this.parent.insertAdjacentHTML('beforeend', controlsMarkup)

	this.controls = this.parent.querySelector('.lay-vimeo-custom-controls')
	this.seekbar = this.controls.querySelector('.lay-vimeo-seekbar')
	this.seekbarInner = this.seekbar.querySelector('.lay-vimeo-seekbar-inner')
	this.playIcon = this.controls.querySelector('.lay-vimeo-play')
	this.pauseIcon = this.controls.querySelector('.lay-vimeo-pause')
	this.playPauseButton = this.controls.querySelector('.lay-vimeo-playpause')
	this.shareButton = this.controls.querySelector('.lay-vimeo-share')
	this.volumeButton = this.controls.querySelector('.lay-vimeo-volume-button')
	this.volumeOnIcon = this.controls.querySelector('.lay-vimeo-volume-on')
	this.volumeOffIcon = this.controls.querySelector('.lay-vimeo-volume-off')
	this.volumeSlider = this.controls.querySelector('.lay-vimeo-volume-slider')
	this.volumeSliderInner = this.controls.querySelector('.lay-vimeo-volume-slider-inner')
	this.seekbarOuter = this.controls.querySelector('.lay-vimeo-seekbar-outer')
	this.volumeSliderOuter = this.controls.querySelector('.lay-vimeo-volume-slider-outer')
	this.fullscreenButton = this.controls.querySelector('.lay-vimeo-fullscreen')
	this.playIconCustom = this.controls.querySelector('.lay-vimeo-playicon-custom')

	// Create fullscreen icon with customizable parameters
	this.createFullscreenIcon = function (options = {}) {
		const defaults = {
			strokeWidth: 2,
			cornerLength: 4,
			color: 'white',
			size: 24,
		}
		const config = { ...defaults, ...options }

		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
		svg.setAttribute('width', config.size)
		svg.setAttribute('height', config.size)
		svg.setAttribute('viewBox', '0 0 24 24')
		svg.setAttribute('fill', 'none')
		svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')

		// Create the 4 corner paths - L shapes pointing outward from center
		const corners = [
			// Top-left corner - L pointing up and left (outward)
			`M${4 + config.cornerLength} 4L4 4L4 ${4 + config.cornerLength}`,
			// Top-right corner - L pointing up and right (outward)
			`M${20 - config.cornerLength} 4L20 4L20 ${4 + config.cornerLength}`,
			// Bottom-left corner - L pointing down and left (outward)
			`M${4 + config.cornerLength} 20L4 20L4 ${20 - config.cornerLength}`,
			// Bottom-right corner - L pointing down and right (outward)
			`M${20 - config.cornerLength} 20L20 20L20 ${20 - config.cornerLength}`,
		]

		corners.forEach((pathData) => {
			const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
			path.setAttribute('d', pathData)
			path.setAttribute('stroke', config.color)
			path.setAttribute('stroke-width', config.strokeWidth)
			path.setAttribute('stroke-linecap', 'round')
			path.setAttribute('stroke-linejoin', 'round')
			svg.appendChild(path)
		})

		return svg
	}

	// Initialize fullscreen icon with default settings
	if (this.fullscreenButton) {
		this.fullscreenButton.appendChild(this.createFullscreenIcon())
	}

	// Method to update fullscreen icon with new parameters
	this.updateFullscreenIcon = function (options = {}) {
		if (this.fullscreenButton) {
			// Clear existing icon
			this.fullscreenButton.innerHTML = ''
			// Create new icon with options
			this.fullscreenButton.appendChild(this.createFullscreenIcon(options))
		}
	}

	// Variables to track dragging state
	this.isSeeking = false
	this.isVolumeDragging = false
	this.lastSeekTime = 0
	this.lastSeekPosition = 0
	this.seekThrottle = 100 // milliseconds between actual seek operations

	var _this = this

	// Seek bar drag functionality - Mouse events
	this.seekbarOuter.addEventListener('mousedown', function (e) {
		e.stopPropagation()
		_this.isSeeking = true
		_this.handleSeek(e)
	})

	// Seek bar drag functionality - Touch events
	this.seekbarOuter.addEventListener('touchstart', function (e) {
		e.stopPropagation()
		_this.isSeeking = true
		_this.handleSeek(e.touches[0])
	})

	document.addEventListener('mousemove', function (e) {
		e.stopPropagation()
		if (_this.isSeeking) {
			_this.handleSeek(e)
		}
		if (_this.isVolumeDragging) {
			_this.handleVolumeDrag(e)
		}
	})

	document.addEventListener(
		'touchmove',
		function (e) {
			if (_this.isSeeking) {
				e.preventDefault()
				e.stopPropagation()
				_this.handleSeek(e.touches[0])
			}
			if (_this.isVolumeDragging) {
				e.preventDefault()
				e.stopPropagation()
				_this.handleVolumeDrag(e.touches[0])
			}
		},
		{ passive: false }
	)

	document.addEventListener('mouseup', function (e) {
		e.stopPropagation()
		_this.isSeeking = false
		_this.isVolumeDragging = false
	})

	document.addEventListener('touchend', function (e) {
		// Do final seek on touchend if we were seeking
		if (_this.isSeeking && _this.lastSeekPosition !== null) {
			_this.video.currentTime = _this.lastSeekPosition * _this.video.duration
		}
		_this.isSeeking = false
		_this.isVolumeDragging = false
		_this.lastSeekPosition = null
	})

	// Volume slider drag functionality - Mouse events
	this.volumeSliderOuter.addEventListener('mousedown', function (e) {
		e.stopPropagation()
		_this.isVolumeDragging = true
		_this.handleVolumeDrag(e)
	})

	// Volume slider drag functionality - Touch events
	this.volumeSliderOuter.addEventListener('touchstart', function (e) {
		e.stopPropagation()
		_this.isVolumeDragging = true
		_this.handleVolumeDrag(e.touches[0])
	})

	// Handle seek during drag
	this.handleSeek = function (e) {
		if (e.stopPropagation) {
			e.stopPropagation()
		}
		var rect = this.seekbarOuter.getBoundingClientRect()
		var pos = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))

		// Always update the UI immediately
		this.seekbarInner.style.width = `${pos * 100}%`
		this.lastSeekPosition = pos

		// Throttle actual video seeking to avoid performance issues
		var now = Date.now()
		if (now - this.lastSeekTime >= this.seekThrottle) {
			this.video.currentTime = pos * this.video.duration
			this.lastSeekTime = now
		}
	}

	// Handle volume during drag
	this.handleVolumeDrag = function (e) {
		var rect = this.volumeSliderOuter.getBoundingClientRect()
		var pos = Math.max(0, Math.min(1, 1 - (e.clientY - rect.top) / rect.height))
		this.video.volume = pos
		this.video.muted = false
		this.updateVolumeSlider(pos, false)
	}

	// Add click handler for seeking (keep existing click handler for single clicks)
	this.seekbarOuter.addEventListener('click', function (e) {
		if (!_this.isSeeking) {
			// Only handle click if not dragging
			var rect = this.getBoundingClientRect()
			var pos = (e.clientX - rect.left) / rect.width
			_this.video.currentTime = pos * _this.video.duration
		}
	})

	// Add click handler to controls container
	this.controls.addEventListener('click', function (e) {
		e.stopPropagation()
		// Only trigger if click was directly on the controls container
		if (e.target === this) {
			if (_this.video.paused) {
				_this.video.play()
				_this.updatePlayPauseIcon(false)
				// we set to dirty to false here, so we autoplay again when scrolled to
				_this.video.dataset.dirty = false
			} else {
				_this.video.pause()
				_this.updatePlayPauseIcon(true)
				// we set dirty to true here so we dont autoplay again when scrolled to
				_this.video.dataset.dirty = true
			}
		}
	})

	// Add click handler to play icon custom overlay
	this.playIconCustom.addEventListener('click', function (e) {
		e.stopPropagation()
		if (_this.video.paused) {
			// Check if video needs to be lazy loaded (has data-src but no src)
			if (_this.video.classList.contains('video-lazyload')) {
				// Load sources directly without using the queue (which calls video.load() asynchronously and could reset playback)
				// Set source.src from data-src
				for (var i = 0; i < _this.video.children.length; i++) {
					var source = _this.video.children[i]
					if (source.tagName === 'SOURCE' && source.dataset.src && !source.src) {
						source.src = source.dataset.src
					}
				}
				_this.video.setAttribute('preload', 'auto')
				_this.video.classList.remove('video-lazyload')
				_this.video.classList.add('loaded')

				// Wait for video to be ready, then play
				// We need to call load() to start loading, but since video is paused it's safe
				_this.video.addEventListener(
					'canplay',
					function playOnReady() {
						_this.video.play()
						_this.video.removeEventListener('canplay', playOnReady)
						_this.video.dataset.dirty = false
					},
					{ once: true }
				)
				// Trigger loading - safe to call load() when video is paused
				try {
					_this.video.load()
				} catch (e) {}
			} else {
				_this.video.play()
				_this.video.dataset.dirty = false
			}
		}
	})

	// Set initial state
	this.updatePlayPauseIcon(this.video.paused)
	if (!this.video.paused) {
		this.parent.classList.add('lay-vimeo-playing')
		this.parent.classList.remove('lay-vimeo-paused')
	} else {
		this.parent.classList.add('lay-vimeo-paused')
		this.parent.classList.remove('lay-vimeo-playing')
	}

	// For videos with placeholder images (lazy loaded), show play icon even if not ready
	// Check if there's a placeholder image in the parent container
	var hasPlaceholder = this.parent.querySelector('.html5-video-placeholder-image')
	if (hasPlaceholder && this.video.paused) {
		// Show play icon immediately for lazy loaded videos with placeholder images
		this.parent.classList.add('lay-vimeo-has-placeholder')
	}

	// Mark as ready when video can play
	this.video.addEventListener('canplay', function () {
		_this.parent.classList.add('lay-vimeo-ready')
	})

	// Also mark as ready immediately if video is already ready
	if (this.video.readyState >= 3) {
		// HAVE_FUTURE_DATA or greater
		this.parent.classList.add('lay-vimeo-ready')
	}

	// Also check on loadedmetadata
	this.video.addEventListener('loadedmetadata', function () {
		_this.parent.classList.add('lay-vimeo-ready')
	})

	// Handle play/pause button click
	this.playPauseButton.addEventListener('click', function (e) {
		e.stopPropagation()
		if (_this.video.paused) {
			_this.video.play()
		} else {
			_this.video.pause()
		}
	})

	// Update icon on play/pause events
	this.video.addEventListener('play', function () {
		_this.updatePlayPauseIcon(false)
		_this.parent.classList.add('lay-vimeo-playing')
		_this.parent.classList.remove('lay-vimeo-paused')
		// Hide placeholder image when video starts playing
		var placeholder = _this.parent.querySelector('.html5-video-placeholder-image')
		if (placeholder) {
			placeholder.style.display = 'none'
		}
	})

	this.video.addEventListener('pause', function () {
		_this.updatePlayPauseIcon(true)
		_this.parent.classList.remove('lay-vimeo-playing')
		_this.parent.classList.add('lay-vimeo-paused')
	})

	this.video.addEventListener('timeupdate', function () {
		if (_this.video.duration > 0) {
			var percent = _this.video.currentTime / _this.video.duration
			_this.seekbarInner.style.width = `${percent * 100}%`
		}
	})

	// Add volume button click handler
	this.volumeButton.addEventListener('click', function (e) {
		e.stopPropagation()
		_this.video.muted = !_this.video.muted
		_this.updateVolumeIcon(!_this.video.muted)
		_this.updateVolumeSlider(_this.video.volume, _this.video.muted)
	})

	// Add volume slider click handler (keep existing click handler for single clicks)
	this.volumeSliderOuter.addEventListener('click', function (e) {
		e.stopPropagation()
		if (!_this.isVolumeDragging) {
			// Only handle click if not dragging
			var rect = this.getBoundingClientRect()
			var pos = 1 - (e.clientY - rect.top) / rect.height
			_this.video.volume = pos
			_this.video.muted = false
			_this.updateVolumeSlider(pos, false)
		}
	})

	// Add fullscreen button click handler
	this.fullscreenButton.addEventListener('click', function (e) {
		e.stopPropagation()

		// Check if we're currently in fullscreen
		const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitDisplayingFullscreen

		if (isFullscreen) {
			// Exit fullscreen
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			}
		} else {
			// Detect iOS
			const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

			if (isIOS && _this.video.webkitEnterFullscreen) {
				// iOS: Use video element fullscreen
				try {
					_this.video.webkitEnterFullscreen()
				} catch (err) {
					console.error('iOS fullscreen failed: ', err)
				}
			} else {
				// Desktop/Android: Try container fullscreen first
				if (_this.parent.requestFullscreen) {
					_this.parent.requestFullscreen()
				} else if (_this.parent.webkitRequestFullscreen) {
					_this.parent.webkitRequestFullscreen()
				} else if (_this.parent.mozRequestFullScreen) {
					_this.parent.mozRequestFullScreen()
				} else if (_this.parent.msRequestFullscreen) {
					_this.parent.msRequestFullscreen()
				}
			}
		}
	})

	// Add share button click handler
	if (this.shareButton) {
		this.shareButton.addEventListener('click', function (e) {
			e.stopPropagation()
			e.preventDefault()
			_this.handleShareClick()
		})
	}

	// Set initial volume state
	this.updateVolumeIcon(!this.video.muted)
	this.updateVolumeSlider(this.video.volume, this.video.muted)

	// Update volume slider on volume change
	this.video.addEventListener('volumechange', function () {
		_this.updateVolumeSlider(_this.video.volume, _this.video.muted)
		_this.updateVolumeIcon(!_this.video.muted)
	})
}

CustomControls.prototype.updatePlayPauseIcon = function (paused) {
	if (paused) {
		this.playIcon.style.display = 'block'
		this.pauseIcon.style.display = 'none'
	} else {
		this.playIcon.style.display = 'none'
		this.pauseIcon.style.display = 'block'
	}
}

CustomControls.prototype.updateVolumeIcon = function (unmuted) {
	if (unmuted) {
		this.volumeOnIcon.style.display = 'block'
		this.volumeOffIcon.style.display = 'none'
	} else {
		this.volumeOnIcon.style.display = 'none'
		this.volumeOffIcon.style.display = 'block'
	}
}

CustomControls.prototype.updateVolumeSlider = function (volume, muted) {
	if (muted) {
		this.volumeSliderInner.style.height = '0%'
	} else {
		this.volumeSliderInner.style.height = `${volume * 100}%`
	}
}

// usually, html5 videos dont have a share button and they dont have a vimeo src. BUT on the elastique website i use a filter
// so that the html5 videos are vimeo videos, and have a share button
CustomControls.prototype.handleShareClick = function () {
	// Get the HTML5 video source URL
	const videoSrc = this.video.src || this.video.currentSrc
	if (!videoSrc) return

	let shareUrl = videoSrc

	// Check if this is a Vimeo video URL
	const vimeoMatch = videoSrc.match(/\/playback\/(\d+)\//)
	if (vimeoMatch) {
		// Extract video ID and create Vimeo share URL
		const videoId = vimeoMatch[1]
		shareUrl = `https://vimeo.com/${videoId}`
	}

	// Check if clipboard API is available (requires HTTPS)
	if (navigator.clipboard && window.isSecureContext) {
		// Use modern clipboard API
		navigator.clipboard
			.writeText(shareUrl)
			.then(() => {
				this.showShareMessage()
			})
			.catch((err) => {
				console.error('Failed to copy URL: ', err)
				// Fallback for older browsers
				this.fallbackCopyToClipboard(shareUrl)
			})
	} else {
		// Use fallback method for Firefox and other browsers
		this.fallbackCopyToClipboard(shareUrl)
	}
}

CustomControls.prototype.fallbackCopyToClipboard = function (text) {
	const textArea = document.createElement('textarea')
	textArea.value = text
	// Make the textarea invisible and position it off-screen
	textArea.style.position = 'fixed'
	textArea.style.left = '-9999px'
	textArea.style.top = '-9999px'
	textArea.style.opacity = '0'
	textArea.style.pointerEvents = 'none'
	document.body.appendChild(textArea)
	textArea.focus()
	textArea.select()
	try {
		document.execCommand('copy')
		this.showShareMessage()
	} catch (err) {
		console.error('Fallback copy failed: ', err)
	}
	document.body.removeChild(textArea)
}

CustomControls.prototype.showShareMessage = function () {
	// Create message element if it doesn't exist
	let messageEl = this.controls.querySelector('.lay-share-message')
	if (!messageEl) {
		this.controls.insertAdjacentHTML('beforeend', '<div class="lay-share-message">Link copied</div>')
		messageEl = this.controls.querySelector('.lay-share-message')
	}

	// Show message with fade in
	messageEl.style.display = 'block'

	// Hide message after 3 seconds
	setTimeout(() => {
		messageEl.style.transition = 'opacity 0.3s ease'
		setTimeout(() => {
			messageEl.style.opacity = '0'
		}, 0)
		setTimeout(() => {
			messageEl.style.display = 'none'
			messageEl.remove()
		}, 300) // Wait for fade out animation
	}, 3000)
}

var initPlayerControls = function ($target) {
	var $html5videos = $target.find('.lay-vimeo-custom-controls video')
	var $html5videos_not_initialized = $html5videos.not('.lay-custom-controls-initialized')
	if ($html5videos_not_initialized.length > 0) {
		$html5videos_not_initialized.addClass('lay-custom-controls-initialized')
		$html5videos_not_initialized.each(function () {
			var $el = jQuery(this)
			new CustomControls($el)
		})
	}
}

var i = function () {
	bindOnContentReady()
}

var html5video_custom_controls = {
	i: i,
}

export default html5video_custom_controls
